type Listener<T> = (event: T) => void;

export interface ApiErrorEvent {
  readonly message: string;
  readonly status?: number;
}

class EventBus<T> {
  private listeners = new Set<Listener<T>>();

  subscribe(fn: Listener<T>): () => void {
    this.listeners.add(fn);
    return () => {
      this.listeners.delete(fn);
    };
  }

  emit(event: T): void {
    this.listeners.forEach((fn) => fn(event));
  }
}

export const API_ERROR_BUS = new EventBus<ApiErrorEvent>();
